/**
 * ScaledCanvas — positioning wrapper for layout items.
 *
 * Scaling moved up to the .shell level: the whole iPad-sized box (header
 * + canvas + footer) is scaled-to-fit by App.tsx, so on desktop the entire
 * editing surface is a true 1180×820 preview. This component no longer
 * scales — it just fills its grid row and provides the absolute-positioning
 * context for EditableItem children.
 *
 * Drag math in EditableItem reads bounds from `.scaled-canvas-inner`. The
 * rendered/design ratio it computes is the same shell-wide scale (since
 * this element is inside the scaled shell), so pointer deltas map back to
 * design pixels correctly.
 *
 * `pageAnimDirection` drives the page-switch slide/fade — rendered as
 * `data-anim` on the inner. The slide uses the standalone CSS `translate:`
 * property so it composes cleanly with any transform on ancestors.
 */

import { type JSX } from 'solid-js';

interface ScaledCanvasProps {
  /** Page-switch animation direction ('left' | 'right' | null). */
  pageAnimDirection?: 'left' | 'right' | null;
  children: JSX.Element;
}

export function ScaledCanvas(props: ScaledCanvasProps) {
  return (
    <div
      class="scaled-canvas-inner"
      data-anim={props.pageAnimDirection ?? ''}
    >
      {props.children}
    </div>
  );
}
